import { InstantEstimateConfig, InstantEstimatePoint } from '../instant-estimate.models';

function points(
  incomes: number[],
  netPrices: number[]
): InstantEstimatePoint[] {
  return incomes.map((income, i) => ({ income, netPrice: netPrices[i] }));
}

const INCOMES = [
  30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 110000, 120000,
  130000, 140000, 150000, 160000, 170000, 180000, 190000, 200000, 210000, 220000,
  230000, 240000, 250000, 260000, 270000, 280000, 290000, 300000,
];

const CORNELL_NPC = [
  5000, 5000, 5000, 5000, 5000, 11372, 13079, 14711, 16448, 18571,
  22890, 25455, 28253, 31286, 34680, 40921, 45100, 49541, 54776, 59502,
  64227, 68952, 73677, 78402, 83127, 87853, 92578, 97303,
];

const AMHERST_NPC = [
  2550, 2550, 2673, 4332, 6011, 7633, 9340, 10971, 13908, 16180,
  18541, 21233, 24180, 27346, 30769, 35148, 39475, 44048, 49283, 54008,
  58733, 63458, 68183, 72909, 77634, 82359, 87084, 97325,
];

const COLBY_NPC = [
  3450, 3450, 3450, 3450, 3450, 7450, 8900, 10300, 11700, 13450,
  15000, 16700, 18450, 20500, 22600, 23450, 23450, 23450, 34450, 37700,
  41050, 44600, 48100, 51600, 55100, 58600, 62100, 65600,
];

export const INSTANT_ESTIMATE_CONFIGS: Record<string, InstantEstimateConfig> = {
  cornell: {
    schoolId: 'cornell',
    schoolName: 'Cornell University',
    costOfAttendance: 97358,
    estimates: points(INCOMES, CORNELL_NPC),
  },
  amherst: {
    schoolId: 'amherst',
    schoolName: 'Amherst College',
    costOfAttendance: 97325,
    estimates: points(INCOMES, AMHERST_NPC),
  },
  colby: {
    schoolId: 'colby',
    schoolName: 'Colby College',
    costOfAttendance: 90970,
    estimates: points(INCOMES, COLBY_NPC),
  },
};
